import { Box, Text, Button, Flex, Icon, Link } from '@chakra-ui/react';
import { BsInfoCircleFill } from 'react-icons/bs';

export const LinkedLoginNudge = () => {
  return (
    <Flex
      bg="rgba(0, 67, 206, 0.1)"
      px="24px"
      py="8px"
      alignItems="center"
      data-test-id="li-settings-nudge"
    >
      <Flex flex="1">
        <Icon
          as={BsInfoCircleFill}
          width="20px"
          height="20px"
          color="#0043CE"
        />
        <Box ml="12px">
          <Text fontWeight="semiBold" fontSize="14px">
            Your LinkedIn settings are out of sync.
          </Text>
          <Text>
            Please make sure the settings are set correctly. Until fixed, all
            Flows with LinkedIn steps will be on hold.
          </Text>
        </Box>
      </Flex>
      <Link color="brand.100" target="_blank">
        <Button
          px="16px"
          onClick={() => {
            window.open(
              'https://www.linkedin.com/mypreferences/d/manage-email-addresses'
            );
          }}
        >
          Set it up
        </Button>
      </Link>
    </Flex>
  );
};
